/* eslint-disable react/prop-types */
import { forwardRef } from 'react';
import TextField from '@mui/material/TextField';
import { styled } from '@mui/material/styles';

const StyledTextField = styled(TextField)({
  marginBottom: 16,
  '& input': {
    borderWidth: 1,
    borderColor: '#E0E1EE',
    borderRadius: 6,
    height: 20,
  },
  '& .MuiOutlinedInput-root': {
    '& fieldset': {
      borderWidth: 1,
    },
    '&:hover fieldset': {
      borderWidth: 1,
    },
    '&.Mui-focused fieldset': {
      borderWidth: 1,
    },
    '& .MuiOutlinedInput-input': {
      padding: 10,
    },
  },
  '& .MuiFormHelperText-root': {
    fontSize: 14,
    margin: 0,
  },
  '& .MuiInputLabel-root': {
    color: '#3c75c7',
    fontWeight: 600,
    fontFamily: 'Source Sans Pro',
    whiteSpace: 'nowrap',
  },
});

// Bridge pre-v9 TextField *Props → slotProps. MUI v9 removed InputProps /
// InputLabelProps / inputProps / etc.; without this, adornments (e.g. password
// visibility) and shrink labels silently stop working.
const FormTextField = forwardRef(
  (
    {
      InputLabelProps,
      InputProps,
      inputProps,
      FormHelperTextProps,
      SelectProps,
      slotProps,
      ...props
    },
    ref,
  ) => (
    <StyledTextField
      /* eslint-disable react/jsx-props-no-spreading */
      {...props}
      slotProps={{
        ...slotProps,
        inputLabel: {
          ...(slotProps?.inputLabel || {}),
          ...(InputLabelProps || {}),
          shrink: true,
        },
        input: {
          ...(slotProps?.input || {}),
          ...(InputProps || {}),
        },
        htmlInput: {
          ...(slotProps?.htmlInput || {}),
          ...(inputProps || {}),
        },
        formHelperText: {
          ...(slotProps?.formHelperText || {}),
          ...(FormHelperTextProps || {}),
        },
        select: {
          ...(slotProps?.select || {}),
          ...(SelectProps || {}),
        },
      }}
      ref={ref}
    />
  ),
);

export default FormTextField;
